var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-up_svg__clip0_2074_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.607 24L19.057 7.089 3.273 23.625 0 20.025 19.176.003 38 20.52 34.607 24z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-up_svg__clip0_2074_6003"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 24)",
    d: "M0 0h38v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDM4IDI0IiBmaWxsPSJub25lIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yMDc0XzYwMDMpIj4KICAgICAgICA8cGF0aCBkPSJNMzQuNjA3MiAyNEwxOS4wNTcxIDcuMDg4OTNMMy4yNzM0OSAyMy42MjVMNC45Mjk0M2UtMDkgMjAuMDI1TDE5LjE3NjQgMC4wMDI5Mjc3OEwzOCAyMC41MTk5TDM0LjYwNzIgMjRaIiBmaWxsPSJ3aGl0ZSIvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8yMDc0XzYwMDMiPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iMzgiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMS4yNDAxZS0wOSAtMSAwIDI0KSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgArrowUp as ReactComponent };